(function () {
  console.log("VIP Checkout Script Loaded");

  async function loadCart() {
    const res = await fetch("/cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    });
    if (!res.ok) throw new Error("Failed to load cart.js");
    return res.json();
  }

  async function handleVipCheckout(event) {
    // Check if this is a checkout button click
    const target = event.target.closest('[data-vip-checkout], button[name="checkout"], #checkout, .cart__checkout-button');
    if (!target) return; // Not a checkout button, let it through

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    
    console.log("VIP Checkout Triggered");

    try {
      const cart = await loadCart();
      console.log("Cart loaded:", cart);

      const vipCustomer = window.__VIP_CUSTOMER__ || null;

      const lines = (cart.items || []).map((item) => {
        const priceInDollars = (item.final_price || item.price) / 100;
        return {
          quantity: item.quantity,
          merchandise: {
            id: `gid://shopify/ProductVariant/${item.variant_id}`,
            price: {
              amount: priceInDollars.toFixed(2),
              currencyCode: cart.currency || "AUD",
            },
            product: {
              title: item.product_title,
            },
          },
        };
      });

      const payload = {
        cart: { lines },
        customer: vipCustomer
          ? { id: vipCustomer.id, email: vipCustomer.email, tags: vipCustomer.tags || [] }
          : null,
      };

      console.log("Sending payload:", payload);

      const res = await fetch(
        "https://wholesaleapp.levdigital.com.au/api/create-draft-order",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) {
        const text = await res.text();
        console.error("VIP checkout HTTP error:", res.status, text);
        alert("Sorry, something went wrong. Please try again.");
        return;
      }

      const data = await res.json();
      console.log("VIP checkout response:", data);

      if (!data.ok || !data.invoiceUrl) {
        console.error("VIP checkout invalid response:", data);
        alert("Sorry, we couldn't create your order. Please use normal checkout.");
        return;
      }

      // Clear cart
      try {
        await fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
      } catch (e) {
        console.log('Cart clear error:', e);
      }

      window.location.href = data.invoiceUrl;

    } catch (err) {
      console.error("VIP checkout error:", err);
      alert("Sorry, an error occurred. Please try again.");
    }
  }

  // Intercept ALL clicks at document level - capture phase runs first
  document.addEventListener("click", handleVipCheckout, { capture: true });
  
  // Also intercept form submissions - but only for checkout, not add-to-cart
  document.addEventListener("submit", function(event) {
    const form = event.target;
    // Only intercept cart page form submissions that are for checkout (not add-to-cart)
    // Check if the submitter is a checkout button
    const submitter = event.submitter;
    const isCheckoutSubmit = submitter && (
      submitter.name === 'checkout' ||
      submitter.id === 'checkout' ||
      submitter.id === 'CartDrawer-Checkout' ||
      submitter.hasAttribute('data-vip-checkout')
    );

    if (isCheckoutSubmit && (form.id === 'cart' || form.id === 'CartDrawer-Form')) {
      console.log("Checkout form submit intercepted");
      event.preventDefault();
      event.stopPropagation();
      handleVipCheckout(event);
    }
  }, { capture: true });

  console.log("VIP checkout document-level handlers attached");
})();
